module.exports = __webpack_public_path__ + "img/3-4.c012b7f9.svg";